// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p6pZ","comment":"styles_comment__2cMNE"};